import { LibraryEffects } from './library/library.effects';
import { MastersEffects } from './masters/masters.effects';

export const Engineeri8AppDBEffects = [MastersEffects, LibraryEffects];
